module.exports = __webpack_public_path__ + "img/ip-img3.ddffd850.png";